import { genericRoute } from 'utils/routeUtils';

import TennisHomePage from './containers/TennisHomePage';
import TennisNav from './nav/TennisNav';

export default genericRoute(TennisHomePage, TennisNav, 'tennis');



// WEBPACK FOOTER //
// ./modules/Tennis/routes.js